import { gql } from '@apollo/client';
import IconRocket from '@apollo/icons/default/IconRocket.svg';
import { IconButton } from '@apollo/orbit';
import React from 'react';
import { Link } from 'react-router-dom';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { GraphRef } from '../../hooks/useGraphRef';
import { launchesRouteConfig } from '../../routes';
import { FlatDiffItemFragment } from '../diffHelpers/diffHelpers';

export const ImplementedChangesFragment = gql`
  fragment ImplementedChangesFragment on Proposal {
    id
    implementedChanges {
      diffItem {
        ...FlatDiffItemFragment
      }
      launchId
      subgraph
    }
  }
  ${FlatDiffItemFragment}
`;

export const ImplementationGutterIndicator = ({
  diffGroupIsPartiallyImplemented,
  implementedChange,
  canQueryLaunches,
  sourceGraphVariant,
  graphRef,
}: {
  diffGroupIsPartiallyImplemented: boolean;
  implementedChange:
    | Omit<
        GraphQLTypes.ImplementedChangesFragment['implementedChanges'][0],
        'subgraph'
      >
    | undefined;
  canQueryLaunches: boolean;
  sourceGraphVariant: string | undefined;
  graphRef: GraphRef;
}) => {
  return implementedChange && sourceGraphVariant ? (
    <Tooltip
      label={
        canQueryLaunches && sourceGraphVariant ? (
          <>
            {diffGroupIsPartiallyImplemented
              ? 'Partially implemented'
              : 'Implemented'}{' '}
            by launch {implementedChange.launchId}. Click to go to launch.
          </>
        ) : (
          <>
            {`This change has been ${
              diffGroupIsPartiallyImplemented ? 'partially ' : ''
            }implemented.`}
          </>
        )
      }
    >
      {canQueryLaunches ? (
        <IconButton
          aria-label="Implemented by launch"
          size="xs"
          variant="hidden"
          className="-mt-[2px] bg-transparent hover:bg-transparent"
          icon={<IconRocket />}
          role="button"
          as={Link}
          to={launchesRouteConfig.location({
            graphId: graphRef.graphId,
            graphVariant: sourceGraphVariant,
            launchId: implementedChange.launchId,
          })}
        />
      ) : (
        <IconRocket className="my-1 ml-2 text-icon-disabled" />
      )}
    </Tooltip>
  ) : null;
};
